<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules"  label-position="top">
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 打款审批</template>
                            <Row :gutter="32">
                                <Col span="24">
                                    <FormItem label="审批" prop="status" :rules="[{required: true, type:'number', message: '请选择审批结果', trigger: 'change',  transform(value) { return parseInt(value)}}]">
                                        <RadioGroup v-model="Forms.status" type="button" button-style="solid">
                                            <Radio :label="7">已打款</Radio>
                                            <Radio :label="6">打款驳回</Radio>
                                        </RadioGroup>
                                    </FormItem>
                                </Col>
                                <Col span="24" v-if="Forms.status === 6">
                                    <FormItem  label="驳回原因" prop="reject_remark" :rules="[{required: true, message: '请输入驳回原因', trigger: 'blur'}]">
                                        <Input v-model="Forms.reject_remark" type="textarea" :rows="4" clearable placeholder="驳回原因"  />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row :gutter="32"  v-if="Forms.status === 7">
                                <Col span="8">
                                    <FormItem label="打款金额" prop="pay_money" :rules="[{ required: true, type: 'number',  message: '请输入打款金额', trigger: 'blur',  transform(value) { return parseFloat(value)}}]">
                                        <Input v-model="Forms.pay_money" type="number" class="width-100" clearable placeholder="如：10000" />
                                    </FormItem>
                                </Col>
                                <Col span="8">
                                    <FormItem label="打款时间" prop="pay_time" :rules="[{required: true, type:'date', message: '请选择打款时间', trigger: 'change'}]">
                                        <DatePicker type="date" format="yyyy-MM-dd" v-model="Forms.pay_time" placeholder="打款时间" class="width-100"  />
                                    </FormItem>
                                </Col>
                                <Col span="8">
                                    <FormItem label="收款账户" prop="pay_account" :rules="[{ required: true, message: '请输入收款账户', trigger: 'blur'}]">
                                        <Input v-model="Forms.pay_account"  class="width-100" clearable placeholder="" />
                                    </FormItem>
                                </Col>
                                <Col span="24">
                                    <FormItem label="打款凭证" prop="pay_image" :rules="[{required: true, type:'array', message: '请上传打款凭证', trigger: 'change'}]">
                                        <Upload
                                            :show-upload-list="false"
                                            :action="upload_url"
                                            :headers = "{'token': $store.state.token}"
                                            :format="['jpg','jpeg','png','gif']"
                                            :max-size="10 * 1024"
                                            :on-success="handleSuccess"
                                            :on-format-error="handleFormatError"
                                            :on-exceeded-size="handleMaxSize"
                                            :before-upload="handleBeforeUpload">
                                            <div class="uploads">
                                                <div class="upload-images-icon cursor" v-if="Forms.pay_image.length < 10">
                                                    <Icon type="md-cloud-upload" size="24" />
                                                    <span>点击上传</span>
                                                </div>
                                                <div class="upload-images" v-for="(item,index) in Forms.pay_image" :key="index" @click.stop="">
                                                    <img :src="site_url + item">
                                                    <div class="show" @click.stop="PhotoView(site_url + item)">预览</div>
                                                    <div class="del" @click.stop="PhotoDelete(index)"><Icon type="md-close" /></div>
                                                </div>
                                            </div>
                                        </Upload>
                                    </FormItem>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 报销信息</template>
                            <DescriptionList class="show-description-title" title="" :col="3"  layout="vertical">
                                <Description term="报销金额：">
                                    <Tag color="blue">{{detail.money}}</Tag>
                                </Description>
                                <Description term="报销编号：">
                                    {{detail.sn}}
                                </Description>
                                <Description term="报销模式：">
                                    {{detail.mode_id === 1 ? '普通报销' : '项目报销'}}
                                </Description>
                                <Description v-if="detail.mode_id === 2" term="报销项目：">
                                    {{detail.project_name}}
                                </Description>
                                <Description term="报销类型：">
                                    {{detail.type_name}}
                                </Description>
                                <Description term="收款账号：">
                                    {{detail.account ?? '-'}}
                                </Description>
                                <Description term="申请人：">
                                    {{detail.apply_name}}
                                </Description>
                                <Description term="申请时间：">
                                    {{detail.apply_time}}
                                </Description>
                                <Description term="审批人：">
                                    {{detail.auditor_name}}
                                </Description>
                                <Description term="审批时间：">
                                    {{detail.auditor_time}}
                                </Description>
                            </DescriptionList>
                            <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical">
                                <Description term="报销凭证">
                                    <div class="uploads">
                                        <div class="upload-images" v-for="(item,index) in detail.image" :key="index" @click.stop="">
                                            <img :src="site_url + item">
                                            <div class="show" @click.stop="PhotoView(site_url + item)">预览</div>
                                        </div>
                                    </div>
                                </Description>
                            </DescriptionList>
                            <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical" v-if="detail.remark">
                                <Description term="备注信息：">
                                    {{detail.remark}}
                                </Description>
                            </DescriptionList>
                        </Card>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">确认打款</Button>
            </div>

            <!-- 预览图片 -->
            <Modal
                v-model="is_view_box"
                title="预览"
                :width="840"
                :mask-closable="true"
                :footer-hide="true"
                @on-cancel="PhotoViewClose()">
                <div class="flex-image-box">
                    <img :src="view_url" class="flex-image-box-show">
                </div>
            </Modal>
        </div>
    </Drawer>
</template>

<script>

import {getExpenseDetail, payExpense} from "@/apis/expense";

export default {
    name: 'IncomeExamine',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '报销打款',
            isBox : false,
            detail: [],
            upload_url : this.$uploadApi,
            site_url : this.$siteApi,
            is_view_box : false,
            view_url : '',
            Forms : {
                id: '',
                status: 7,
                reject_remark: '',
                pay_money: '',
                pay_time: '',
                pay_account: '',
                pay_image: []
            },
            Rules : {

            }
        }
    },
    methods: {
        /**
         功能：图片预览
         time: 2025-17-15 10:17:00
         **/
        PhotoView(url){
            if(url){
                this.view_url = url;
                this.is_view_box = true;
            }
        },
        /**
         功能：图片删除
         time: 2025/12/15 10:21
         **/
        PhotoDelete(index){
            let that = this;
            that.Forms.pay_image.splice(index , 1);
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleSuccess(res){
            let that = this;
            if(res.code == 100){
                this.Forms.pay_image.push(res.data.url);
            }else{
                that.$Message.error({ background: true,duration:3, content: res.msg});
            }
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleFormatError(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '只支持 jpg | png | gif 文件 ' });
            return false;
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleMaxSize(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '图片大小不能超出 10M' });
            return false;
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleBeforeUpload(){
            let that = this;
            if(that.Forms.pay_image.length >= 10){
                that.$Message.error({ background: true,duration:3, content: '最多只能上传 10 张图' });
                return false;
            }
            return true;
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        PhotoViewClose(){
            this.is_view_box = false;
            this.view_url = '';
        },

        /**
         功能：
         time: 2025/12/17 16:04
         **/
        GetDetail(id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getExpenseDetail(id).then(e => {
                that.detail = e.data;
                that.title = e.data.apply_name + ' 的报销打款';
                that.Forms.pay_account = e.data.account ?? '';
            })
        },
        /**
         功能：
         time: 2025/12/17 10:47
         **/
        show(id){
            this.isBox = true;
            if(id){
                this.Forms.id = id;
                this.GetDetail(id);
            }
        },
        /**
         功能：
         time: 2025/12/26 16:14
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    payExpense(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025/12/20 11:54
         **/
        FormReset(){
            this.isBox = false;
            this.title = '报销打款';
            this.$refs['Forms'].resetFields();
            this.Forms = {
                id: '',
                status: 7,
                reject_remark: '',
                pay_money: '',
                pay_time: '',
                pay_account: '',
                pay_image: []
            };
            this.detail = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
